<template>
	<div class="home-page-echarts">
		<div id="echartId" style="height:100%;"></div>
    <div id="echartBar" class="echartBar"></div>
    <div class="action-button">
      <a-icon class="action-icon" @click="scaleMap('add')" type="plus-square" />
      <br />
      <a-icon class="action-icon" @click="scaleMap()" type="minus-square" />
    </div>
	</div>
</template>

<script>
  export default {
    data() {
      return {
        myChart: null,
        mayBar: null,
        echartData: []
      };
    },
    props: ['params', 'showTitle'],
    mounted() {
      this.getStat();
    },
    watch: {
      params() {
        this.getStat();
      }
    },
    methods: {
      getStat() {
        this.$get("stat", this.params).then(res => {
          this.echartData = [];
          const sortData = res.data.data.sort(function (a, b) {
            return a.num - b.num;
          });
          sortData.forEach(item => {
            let params = {
              name: item.deptName,
              value: [item.hospitalLongitude, item.hospitalLatitude, item.num, item.hospitalAddress, item.piNum],
              logoImg: item.logoImg,
              itemStyle: {
                normal: {
                  color: '#428ef7',
                  shadowBlur: 10,
                  shadowColor: 'rgba(0, 0, 0, 0.5);'
                }
              }
            }
            if(item.logoImg) {params.symbol = `image://${item.logoImg}`;}
            this.echartData.push(params);
          });
          this.initEcharts();
          this.initBar();
        });
      },
      scaleMap(ope) {
        const option =this.myChart.getOption().geo[0].zoom;
        let num = ope == 'add'? option+0.15:option-0.15;
        num = num <= 0?num+0.15:num;
        this.myChart.setOption({
          geo: {
            zoom: num
          }
        })
      },
      initEcharts() {
        this.myChart = this.$echarts.init(document.getElementById("echartId"));
        // 绘制图表
        let option = {
          backgroundColor: '#eef6ff',
          title: {
            text: ""
          },
          geo: {
            map: 'china',
            roam: true,
            left: '0',
            right: '38%',
            label: {
              emphasis: {
                show: false
              }
            },
            scaleLimit: {
              min: 0
            },
            zoom: 1.5,
            center: [110.666666,30.666666],
            itemStyle: {
              normal: {
                areaColor: '#c4c5c6',
                borderColor: '#fff',//线
                borderWidth: 2,
                shadowBlur: 0,
                shadowColor: 'rgba(0,0,0,0)',
              },
				      emphasis: {
                areaColor: '#c4c5c6',//悬浮区背景
              }
            }
          },
          tooltip: {
            trigger: "item",
            formatter: (params, ticket, callback) => {
              let resHtml = [];
              resHtml.push('<div style="font-size: 12px;">' + params.data.name + '</div>');
              resHtml.push('<div style="font-size: 12px; padding-bottom: 3px;">地址：' + params.value[3] + '</div>');
              resHtml.push('<div style="font-size: 12px;">患者数量：' + params.value[2] + '</div>');
              resHtml.push('<div style="font-size: 12px;">就诊流程数量：' + params.value[4] + '</div>');
              this.setBar(params);
              return resHtml.join('');
            }
          },
          series: [
            {
              name: "Top 5",
              type: "scatter",
              coordinateSystem: "geo",
              data: this.echartData,
              symbolSize: (value, params)=> {
                return params.data.logoImg? '38':'20';
              },
              emphasis: {
                itemStyle: {
                  // borderWidth: 3,
                  // borderColor: '#428EF7',
                  shadowBlur: 10,
                  shadowColor: 'rgba(0,0,0,0.5)',
                }
              },
              hoverAnimation: true,
            }
          ]
        };
        if(this.showTitle == 'true') {
          option.title = {
            text: "医院样本量",
            top: '30',
            left: '15',
            textStyle: {
              color: '#333',
              fontSize: 14
            }
          };
        }
        this.myChart.setOption(option);
      },
      initBar() {
        this.myBar = this.$echarts.init(document.getElementById('echartBar'));
        let option = {
          title: [{
            text: ''
          }],
          tooltip: {
            trigger: "item",
            formatter: (params, ticket, callback) => {
              return `就诊流程数量：${params.value}`;
            }
          },
          grid: {
            id: 'echart-bar',
            right: 30,
            top: 80,
            bottom: 30,
            show: true,
            width: '45%',
            borderWidth: 0
          },
          xAxis: {
            type: 'value',
            scale: true,
            position: 'top',
            min: 0,
            boundaryGap: false,
            splitLine: {show: false},
            axisLine: {show: false},
            axisTick: {show: false},
            axisLabel: {margin: 2, textStyle: {color: '#333'}},
          },
          yAxis: {
            type: 'category',
            name: '',
            nameGap: 16,
            axisLine: {show: false, lineStyle: {color: '#333'}},
            axisTick: {show: false, lineStyle: {color: '#333'}},
            axisLabel: {interval: 0, textStyle: {color: '#333'}},
            data: []
          },
          series: [
            {
              type: 'bar',
              barWidth: 10,
              data: [],
              zlevel: 11
            }
          ]
        };
        if(this.showTitle == 'false') {
          option.grid.top = 60;
        }
        this.myBar.setOption(option);
        this.setBar();
      },
      setBar(params) {
        const id = params?params.dataIndex:'';
        let categoryData = [];
        let barData = [];
        this.echartData.forEach((item, index) => {
          categoryData.push(item.name);
          barData.push(item.value[2]);
        });
        this.myBar.setOption({
          yAxis: {
            data: categoryData
          },   
          title: {
            id: 'statistic'
          },  
          series: {
            type: 'bar',
            data: barData,
            itemStyle: {
              normal: {
                color: function(param) {
                  const num = params&&id===param.dataIndex?1:0;
                  var colorList = ["#29CC97", "#428EF7"];
                  return colorList[num];
                }
              }
            },
          }
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
	.home-page-echarts {
		height: 550px;
    margin-bottom: 50px;
		width: 100%;
		position: relative;
		.btn-down-img {
			position: absolute;
			right: 10px;
			top: 10px;
			z-index: 10;
		}
    .echartBar {
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      width: 42%;
      background: rgba(255,255,255,.6);
    }
    .action-button {
      position: absolute;
      left: 0;
      bottom: 0;
      background: rgba(255,255,255,.8);
      border-radius: 4px;
    }
    .action-icon {
      cursor: pointer;
      font-size: 16px;
      padding: 5px 2px;
      color: #666;
    }
    .action-icon:first-child {
      border-bottom: 1px solid #f0f2f5;
    }
	}
</style>